module.exports = __webpack_public_path__ + "img/4.35f73821.jpg";